<template>
  <div>
    <div v-for="(e, index) in contractData" :key="index" class="contractList" @click="goToContractDetail(e)">
      <div class="contractItemHeader">
        <div class="contractItemHeaderTitie">{{e.productName}}</div>
        <div class="contractItemHeaderTime">{{e.createTime}}</div>
      </div>

      <div class="contractItemCenter">
        <div class="contractText">{{e.loanAmount/ 10000}}万元</div>
        <div class="contractItemCenterRight">
          <div class="contractText">
            {{e.term}}
          </div>
          <van-icon class="arrowIcon" name="arrow" />
        </div>
      </div>

      <div class="contractItemFooter contractText">
        {{e.corpName}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contractList',
  data() {
    return {};
  },
  props: ['contractData'],
  methods: {
    goToContractDetail(e) {
      this.$router.push({
        path: '/supermarket/v2/contractDetail',
        query: {
          orderId: e.orderId,
        },
      });
    },
  },
};
</script>
<style scoped>
.contractList{
  height: 83px;
  margin-top: 8px;
  padding: 8px 16px;
  background: #fff;
}
.contractItemHeader{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.contractItemHeaderTitie{
  font-family: PingFangSC-Medium;
  font-size: 17px;
}
.contractItemHeaderTime{
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #9EA7B4;
}
.contractItemCenter{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3px;
}
.contractItemFooter{
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
}
.contractItemCenterRight{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.contractText{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #495060;
}
.arrowIcon{
  font-size: 18px;
  margin-left: 4px;
  color: #80848F;
}
</style>
